import MultiSelectFilterField from "./MultiSelectFilterField";

type TagOption = { id: string; label: string };

type Props = {
  label?: string;
  value: string[];
  onChange: (value: string[]) => void;
  options: TagOption[];
  showLabel?: boolean;
};

const TagsAutocompleteFilterField = ({
  label,
  value,
  onChange,
  options,
  showLabel = true,
}: Props) => {
  return (
    <MultiSelectFilterField
      label={label}
      value={value}
      onChange={onChange}
      options={options.map((o) => ({ value: o.id, label: o.label }))}
      showLabel={showLabel}
      placeholder="Select"
    />
  );
};

export default TagsAutocompleteFilterField;
